module.exports = __webpack_public_path__ + "static/media/boek_01.6df1828e.png";